module.exports = __webpack_public_path__ + "img/video-pic5.2e459468.jpg";